import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import axiosInstance, { version } from '../../config/Api';
import { getTopMenu } from '../actions/Publication';

class AricleSubmissionForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            path:'',
            header:{},
            container:{},
            menu: {},
            footer:{},
            layout_id:'',
            article_data:{
              "article-for":"",
              "article-summery":"",
              "article-category":"",
              "article-file":""
            },
            article_data_validator:{
                "article-for":"",
                "article-summery":"",
                "article-category":"",
                "article-file":""
            },
            author_data:[{
                "author-name":"",
                "author-profession":"",
                "author-designation":"",
                "author-organization":"",
                "author-mobile":"",
                "author-email":"",
                "author-profile-brief":"",
                "author-image":"",

            }],
            author_data_validator:[{
                "author-name":"",
                "author-profession":"",
                "author-designation":"",
                "author-organization":"",
                "author-mobile":"",
                "author-email":"",
                "author-profile-brief":"",
                "author-image":"",

            }],
            message:'',
            message_type:'',
        };
    }
    componentDidMount = () => {
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        this.props.getTopMenu().then((res) => {
            console.log(this.props);
            this.setState({
                menu: res
            })
        });
              
    }
    handleAddmoreAuthor=(e)=>
    {
        e.preventDefault();
        if(this.state.author_data.length <3)
        {
          var new_obj={
              "author-name":"",
              "author-profession":"",
              "author-designation":"",
              "author-organization":"",
              "author-mobile":"",
              "author-email":"",
              "author-profile-brief":"",
              "author-image":"",
          };
          var new_obj_validate={
            "author-name":"",
            "author-profession":"",
            "author-designation":"",
            "author-organization":"",
            "author-mobile":"",
            "author-email":"",
            "author-profile-brief":"",
            "author-image":"",
          };
          this.setState({author_data:[...this.state.author_data,new_obj]});
          this.setState({author_data_validator:[...this.state.author_data_validator,new_obj_validate]});
      }
    } 
    handleRemoveAuthor=(e,index)=>
    {
        e.preventDefault();
        this.state.author_data.splice(index,1);
        this.state.author_data_validator.splice(index,1);
        this.setState({author_data:[...this.state.author_data]})
        this.setState({author_data_validator:[...this.state.author_data_validator]})
    }
    handleAuthoInputChange=(e,index)=>
    {
        e.preventDefault();
        const{name,value}=e.target;
        var author_data=[...this.state.author_data];
        author_data[index][name]=value;
        this.setState((prevState) => {
            return {
                author_data: author_data,
            }
        });
    }
    handleArticleInputData=(e)=>
    {
        const{name,value}=e.target;
        var article_data={...this.state.article_data};
        article_data[name]=value;
        this.setState((prevState) => {
            return {
                article_data: article_data,
            };
            
        });
        
    }
    handleArticleFile=(e)=>{
        const{name}=e.target;
        const{files}=e.target;
        var article_data={...this.state.article_data};
        article_data[name]=files;
        this.setState((prevState) => {
            return {
                article_data: article_data,
            };
        });
    }
    handleAuthorFile=(e,index)=>{
        e.preventDefault();
        const{name}=e.target;
        const{files}=e.target;
        var author_data=[...this.state.author_data];
        author_data[index][name]=files[0];
        this.setState((prevState) => {
            return {
                author_data: author_data,
            }
        });
    }
    hadleFormSubmit=(e)=>{
        e.preventDefault();
        var is_validation=true;
        const {article_data_validator,author_data_validator,author_data,article_data} = this.state;
        const post_data=new FormData();
        var allowedExtensionsForAuthorFile=/(\.jpg|\.jpeg|\.png|\.gif)$/i;
        author_data.map((row,key)=>{
            
            for(var x  in row)
            {
              if(x=='author-image')
              {
                var image_size=(row[x].size/1000)/1000;
                var file=(row[x].name);
                if(!row[x])
                {
                  author_data_validator[key][x]="The Field Is Required";
                  is_validation=false;
                }
                else if(image_size > 2)
                {
                  author_data_validator[key][x]="File Size Exceed. Max File Size 2 MB";
                  is_validation=false;
                }
                else if(!allowedExtensionsForAuthorFile.exec(file)) {
                  author_data_validator[key][x]="Only JPG, JPEG, PNG, GIF Allowed";
                  is_validation=false;
                }
                else
                {
                  post_data.append(x+"["+key+"]",row[x]);
                  author_data_validator[key][x]="";
                }
              }
              else{
                if(!row[x])
                {
                  author_data_validator[key][x]="The Field Is Required";
                  is_validation=false;
                }
                else{
                  post_data.append(x+"["+key+"]",row[x]);
                  author_data_validator[key][x]="";
                }
              }
            }
        });
        var allowedExtensionsForArticleData =/(\.doc|\.docx|\.pdf)$/i;
        for(var x  in article_data)
        {
          if(x==='article-file')
          {
              if(!article_data[x])
              {
                is_validation=false;
                article_data_validator[x]="The Field Is Required";
              }
            for (let i = 0; i < article_data[x].length; i++) {
                var image_size=(article_data[x][i].size/1000)/1000;
                var file=(article_data[x][i].name);
                if(image_size > 10)
                {
                  article_data_validator[x]="File Size Exceed. Max File Size 10 MB";
                  is_validation=false;
                }
                else if(!allowedExtensionsForArticleData.exec(file)) {
                  article_data_validator[x]="Only Word,Pdf Allowed";
                  is_validation=false;
                }
                
                else
                {
                  post_data.append(x+"[]", article_data[x][i]);
                  article_data_validator[x]="";
                }
            }
          }
          else
          {
            if(!article_data[x])
            {
              is_validation=false;
              article_data_validator[x]="The Field Is Required";
            }
            else{
            article_data_validator[x]="";
            post_data.append(x,article_data[x]);
            }
          }
        }
        this.setState({author_data_validator:[...this.state.author_data_validator,author_data_validator]});
        this.setState({article_data_validator:{...this.state.article_data_validator,article_data_validator}});
        // is_validation=true;
        if(is_validation==true)
        {
           axiosInstance.post(version+'post_article_submission',post_data).then((res)=>{
             console.log(res);
            this.setState({message:res.data,message_type:'success'})
            this.setState({article_data:{
                "article-for":"",
                "article-summery":"",
                "article-category":"",
                "article-file":""
              },
              article_data_validator:{
                  "article-for":"",
                  "article-summery":"",
                  "article-category":"",
                  "article-file":""
              }
            });

            this.setState({
              author_data:[{
                  "author-name":"",
                  "author-profession":"",
                  "author-designation":"",
                  "author-organization":"",
                  "author-mobile":"",
                  "author-email":"",
                  "author-profile-brief":"",
                  "author-image":"",

              }],
              author_data_validator:[{
                  "author-name":"",
                  "author-profession":"",
                  "author-designation":"",
                  "author-organization":"",
                  "author-mobile":"",
                  "author-email":"",
                  "author-profile-brief":"",
                  "author-image":"",

              }]
            });
           }).catch(error => {
            this.setState({message:error.data,message_type:'danger'})
            this.setState({article_data:{
                "article-for":"",
                "article-summery":"",
                "article-category":"",
                "article-file":""
              },
              article_data_validator:{
                  "article-for":"",
                  "article-summery":"",
                  "article-category":"",
                  "article-file":""
              }
            });

            this.setState({
              author_data:[{
                  "author-name":"",
                  "author-profession":"",
                  "author-designation":"",
                  "author-organization":"",
                  "author-mobile":"",
                  "author-email":"",
                  "author-profile-brief":"",
                  "author-image":"",

              }],
              author_data_validator:[{
                  "author-name":"",
                  "author-profession":"",
                  "author-designation":"",
                  "author-organization":"",
                  "author-mobile":"",
                  "author-email":"",
                  "author-profile-brief":"",
                  "author-image":"",

              }]
            });
           });
        }
    }
    handleMessageClose = () => {
      this.setState({message:'',message_type:''})
    }
    render() {
        const {article_data_validator,author_data_validator} = this.state;
        const top_menu = this.props.headers.top_menu;
            return (
                <Fragment>
                   <section className="article-submission-page">
                        <div className="container">
                        <div className="row">
                            {this.state.message !='' && this.state.message_type =='success' && <div className="col-sm-12" >
                                    <div className="alert  alert-success alert-dismissible fade show" role="alert">
                                        {this.state.message}
                                        <button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={()=>this.handleMessageClose()}>
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                </div>}
                                {this.state.message !='' && this.state.message_type =='danger' && <div className="col-sm-12">
                                    <div className="alert  alert-danger alert-dismissible fade show" role="alert">
                                        {this.state.message}
                                        <button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={()=>this.handleMessageClose()}>
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                </div>}
                        </div>
                            <div className="article-submission-form">
                            
                                <h2>Online Form for Submission of Article</h2>

                                <form>
                                    <h4>1.  Name of Author(s)</h4>
                                    {
                                        this.state.author_data.map((row,key)=>{
                                            return (
                                              <div
                                                className="row author"
                                                key={key}
                                              >
                                                <div className="col-md-6">
                                                  <label>Author's Name</label>
                                                  <input
                                                    type="text"
                                                    name="author-name"
                                                    onChange={(e) => this.handleAuthoInputChange(e,key)}
                                                    value={row["author-name"]}
                                                    require="required"
                                                    className={(typeof author_data_validator[key] != undefined && typeof author_data_validator[key]["author-name"] != undefined && author_data_validator[key]["author-name"]? "input-erro ": "") + "form-control"}
                                                  />
                                                  {author_data_validator[key]["author-name"]&& (
                                                        <span className="help-block form-text text-danger">
                                                        {author_data_validator[key]["author-name"]}
                                                        </span>
                                                    )}
                                                </div>
                                                <div className="col-md-6">
                                                  <label>Profession</label>
                                                  <input
                                                    type="text"
                                                    name="author-profession"
                                                    onChange={(e) =>this.handleAuthoInputChange( e,key)}
                                                    value={row["author-profession"]}
                                                    className={(typeof author_data_validator[key] != undefined && typeof author_data_validator[key]["author-profession"] != undefined && author_data_validator[key]["author-profession"]? "input-erro ": "") + "form-control"}
                                                    />
                                                    {author_data_validator[key]["author-profession"]&& (
                                                          <span className="help-block form-text text-danger">
                                                          {author_data_validator[key]["author-profession"]}
                                                          </span>
                                                      )}
                                                </div>
                                                <div className="col-md-6">
                                                  <label>Designation</label>
                                                  <input
                                                    type="text"
                                                    name="author-designation"
                                                    onChange={(e) =>
                                                      this.handleAuthoInputChange(
                                                        e,
                                                        key
                                                      )
                                                    }
                                                    value={
                                                      row["author-designation"]
                                                    }
                                                    className={(typeof author_data_validator[key] != undefined && typeof author_data_validator[key]["author-designation"] != undefined && author_data_validator[key]["author-designation"]? "input-erro ": "") + "form-control"}
                                                    />
                                                    {author_data_validator[key]["author-designation"]&& (
                                                          <span className="help-block form-text text-danger">
                                                          {author_data_validator[key]["author-designation"]}
                                                          </span>
                                                      )}
                                                </div>
                                                <div className="col-md-6">
                                                  <label>Organization</label>
                                                  <input
                                                    type="text"
                                                    name="author-organization"
                                                    onChange={(e) =>
                                                      this.handleAuthoInputChange(
                                                        e,
                                                        key
                                                      )
                                                    }
                                                    value={
                                                      row["author-organization"]
                                                    }
                                                    className={(typeof author_data_validator[key] != undefined && typeof author_data_validator[key]["author-organization"] != undefined && author_data_validator[key]["author-organization"]? "input-erro ": "") + "form-control"}
                                                    />
                                                    {author_data_validator[key]["author-organization"]&& (
                                                          <span className="help-block form-text text-danger">
                                                          {author_data_validator[key]["author-organization"]}
                                                          </span>
                                                      )}
                                                </div>

                                                <div className="col-md-6">
                                                  <label>Mobile</label>
                                                  <input
                                                    type="number"
                                                    name="author-mobile"
                                                    onChange={(e) =>
                                                      this.handleAuthoInputChange(
                                                        e,
                                                        key
                                                      )
                                                    }
                                                    value={row["author-mobile"]}
                                                    className={(typeof author_data_validator[key] != undefined && typeof author_data_validator[key]["author-mobile"] != undefined && author_data_validator[key]["author-mobile"]? "input-erro ": "") + "form-control"}
                                                  />
                                                    {author_data_validator[key]["author-mobile"]&& (
                                                          <span className="help-block form-text text-danger">
                                                          {author_data_validator[key]["author-mobile"]}
                                                          </span>
                                                      )}
                                                </div>

                                                <div className="col-md-6">
                                                  <label>Email</label>
                                                  <input
                                                    type="email"
                                                    name="author-email"
                                                    onChange={(e) =>
                                                      this.handleAuthoInputChange(
                                                        e,
                                                        key
                                                      )
                                                    }
                                                    value={row["author-email"]}
                                                    className={(typeof author_data_validator[key] != undefined && typeof author_data_validator[key]["author-email"] != undefined && author_data_validator[key]["author-email"]? "input-erro ": "") + "form-control"}
                                                  />
                                                  {author_data_validator[key]["author-email"]&& (
                                                        <span className="help-block form-text text-danger">
                                                        {author_data_validator[key]["author-email"]}
                                                        </span>
                                                    )}
                                                </div>

                                                <div className="col-md-6">
                                                  <label>
                                                    Brief Profile of writer (not
                                                    more than 100 words)
                                                  </label>
                                                  <textarea
                                                    onChange={(e) =>this.handleAuthoInputChange(e, key)}
                                                    name="author-profile-brief"
                                                    value={row["author-profile-brief"]}
                                                    className={(typeof author_data_validator[key] != undefined && typeof author_data_validator[key]["author-profile-brief"] != undefined && author_data_validator[key]["author-profile-brief"]? "input-erro ": "") + "form-control"}
                                                    />
                                                    {author_data_validator[key]["author-profile-brief"]&& (
                                                          <span className="help-block form-text text-danger">
                                                          {author_data_validator[key]["author-profile-brief"]}
                                                          </span>
                                                      )}
                                                </div>
                                                <div className="col-md-6">
                                                  <label>Upload Photo</label>
                                                  {
                                                    row['author-image']?
                                                      <input
                                                        type="file"
                                                        accept="image/*"
                                                        onChange={(e) =>this.handleAuthorFile(e,key)}
                                                        className="btn btn-outline-secondary"
                                                        name="author-image"
                                                        
                                                      />
                                                    :
                                                    <input
                                                      type="file"
                                                      accept="image/*"
                                                      onChange={(e) =>this.handleAuthorFile(e,key)}
                                                      className="btn btn-outline-secondary"
                                                      name="author-image"
                                                      value=""
                                                    />
                                                  }
                                                  {author_data_validator[key]["author-image"]&& (
                                                          <span className="help-block form-text text-danger">
                                                          {author_data_validator[key]["author-image"]}
                                                          </span>
                                                      )}
                                                </div>
                                                <div className="col-md-6">
                                                  {this.state.author_data.length -1 ==key && key<2 && (
                                                    <button
                                                      onClick={(e) =>this.handleAddmoreAuthor(e,key )}
                                                      className="btn btn-success"
                                                    >
                                                      Add More
                                                    </button>
                                                  )}
                                                  {key != 0 && (
                                                    <button
                                                      onClick={(e) =>this.handleRemoveAuthor( e, key)}
                                                      className="btn btn-danger"
                                                    >
                                                      Remove
                                                    </button>
                                                  )}
                                                </div>
                                              </div>
                                            );
                                        })
                                    }
                                    
                                    
                                    <div className="row">
                                        <div className="col-md-6">
                                          <h4>2.  Article Submission for</h4>
                                          <div className="form-check">
                                              <input type="checkbox" name="article-for" onChange={(e)=>this.handleArticleInputData(e)} checked={this.state.article_data['article-for']=='The Bangladesh Accountant'} className="form-check-input" id="submissionfor1" value="The Bangladesh Accountant"/>
                                              <label className="form-check-label" for="submissionfor1" >a. The Bangladesh Accountant </label>
                                          </div>
                                          <div className="form-check">
                                              <input type="checkbox" name="article-for" onChange={(e)=>this.handleArticleInputData(e)} checked={this.state.article_data['article-for']=='Bangladesh Economia'} className="form-check-input" id="submissionfor2" value="Bangladesh Economia"/>
                                              <label className="form-check-label" for="submissionfor2" >b. Bangladesh Economia </label>
                                          </div>
                                          {article_data_validator["article-for"]&& (
                                                <span className="help-block form-text text-danger">
                                                {article_data_validator["article-for"]}
                                                </span>
                                            )}
                                        </div>
                                        <div className="col-md-6">
                                            <h4>3.  Summary of Article</h4>
                                            <textarea className="form-control" onChange={(e)=>this.handleArticleInputData(e)}  value={this.state.article_data['article-summery']} name="article-summery" />
                                            {article_data_validator["article-summery"]&& (
                                              <span className="help-block form-text text-danger">
                                              {article_data_validator["article-summery"]}
                                              </span>
                                            )}
                                        </div>
                                        <div className="col-md-12">
                                            <h4>4.  Category of Article</h4>
                                            {top_menu.length ? <Fragment>
                                            {top_menu.map((row, key) => {
                                                return (
                                                    <Fragment key={key}>
                                                        
                                                        {(row.showing_position === 2 || row.showing_position === 3) &&
                                                            
                                                            <div className="form-check form-check-inline">
                                                                <input type="checkbox" name="article-category" checked={this.state.article_data['article-category']===row.category_name} onChange={(e)=>this.handleArticleInputData(e)}  className="form-check-input" id={"exampleCheck"+key} value={row.category_name}/>
                                                                <label className="form-check-label" for={"exampleCheck"+key}>{row.category_name}</label>
                                                            </div>
                                                        }
                                                    </Fragment>
                                                )
                                            })}
                                            {article_data_validator["article-category"]&& (
                                              <span className="help-block form-text text-danger">
                                              {article_data_validator["article-category"]}
                                              </span>
                                            )}
                                            </Fragment> : ''}
                                        </div>
                                    </div>
                                    <div className="mt-3 row">
                                        <div className="col-md-6">
                                            <label>Upload Articles</label>
                                            {
                                              this.state.article_data['article-file']?
                                              <input type="file"  accept="application/msword,application/pdf,"  name="article-file" multiple className="btn btn-outline-secondary" onChange={(e)=>this.handleArticleFile(e)}/>
                                              :
                                              <input type="file"  accept="application/msword,application/pdf,"  name="article-file" multiple className="btn btn-outline-secondary" onChange={(e)=>this.handleArticleFile(e)} value="" />
                                            }
                                            
                                            {article_data_validator["article-file"]&& (
                                              <span className="help-block form-text text-danger">
                                              {article_data_validator["article-file"]}
                                              </span>
                                            )}
                                        </div>
                                    </div>
                                    <input type="submit" className="btn btn-primary" onClick={(e)=>this.hadleFormSubmit(e)}/>
                                </form>
                            </div>
                        </div>
                    </section>
                </Fragment>
            )
        
    }
}

const mapStateToProps = state => ({
    headers: state.pubheader,
    
})

const mapDispatchToProps = dispatch => ({
    getTopMenu: (requestData) => dispatch(getTopMenu(requestData))
})

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(AricleSubmissionForm));